import { Expose, Transform } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export type TwoFactorMethod = 'totp' | 'email'

export class AuthData extends Entity<AuthData> {
    @Expose()
    accessToken!: string

    @Expose()
    refreshToken!: string

    @Expose()
    @Transform(value => value || false)
    twoFactor!: boolean

    @Expose()
    @Transform(value => value || false)
    twoFactorSetup!: boolean

    @Expose()
    consumerId!: string

    @Expose()
    @Transform(value => value || 'totp')
    twoFactorMethod!: TwoFactorMethod

    @Expose()
    maskedEmail?: string

    @Expose()
    emailOtpExpiresAt?: string

    // Rate limit / lockout state from existing database records
    @Expose({ name: 'verify_rate_limited' })
    verifyRateLimited?: boolean

    @Expose({ name: 'verify_lockout_seconds' })
    verifyLockoutSeconds?: number

    @Expose({ name: 'email_rate_limited' })
    emailRateLimited?: boolean

    @Expose({ name: 'email_lockout_seconds' })
    emailLockoutSeconds?: number
}
